import fonts from './fonts'

const textStyles = {
  titleH1_36: `
    ${fonts.HelveticaNeueBold}
    font-size: 3.6rem;
  `,
  titleH1_26: `
    ${fonts.HelveticaNeueBold}
    font-size: 2.6rem;
  `,
  titleH2_30: `
    ${fonts.HelveticaNeueBold}
    font-size: 3rem;
  `,
  titleH2_23: `
    ${fonts.HelveticaNeueBold}
    font-size: 2.3rem;
  `,
  text_bold_condensed_12: `
    ${fonts.MarianneBold}
    font-size: 1.2rem;
    text-transform: uppercase;
  `,
  text_bold_condensed_14: `
    ${fonts.MarianneBold}
    font-size: 1.4rem;
    text-transform: uppercase;
  `,
  text_bold_condensed_15: `
    ${fonts.MarianneBold}
    font-size: 1.5rem;
    text-transform: uppercase;
  `,
  text_bold_condensed_16: `
    ${fonts.MarianneBold}
    font-size: 1.6rem;
    text-transform: uppercase;
  `,
  text_bold_condensed_18: `
    ${fonts.MarianneBold}
    font-size: 1.8rem;
    text-transform: uppercase;
  `,
  text_bold_condensed_20: `
    ${fonts.MarianneBold}
    font-size: 2rem;
    text-transform: uppercase;
  `,
  text_14: `
    ${fonts.HelveticaNeue}
    font-size: 1.4rem;
    letter-spacing: 0;
    line-height: 1.45;
  `,
  text_15: `
    ${fonts.HelveticaNeue}
    font-size: 1.5rem;
    letter-spacing: 0;
    line-height: 1.45;
  `,
  text_16: `
    ${fonts.HelveticaNeue}
    font-size: 1.6rem;
    letter-spacing: 0;
    line-height: 1.45;
  `,
  text_18: `
    ${fonts.HelveticaNeue}
    font-size: 1.8rem;
    letter-spacing: 0;
    line-height: 1.45;
  `,
  text_22: `
    ${fonts.HelveticaNeue}
    font-size: 2.2rem;
    font-weight: 400;
  `,
  text_24: `
    ${fonts.HelveticaNeue}
    font-size: 2.4rem;
  `,
  text_bold_14: `
    ${fonts.MarianneBold}
    font-size: 1.4rem;
  `,
  text_bold_16: `
    ${fonts.MarianneBold}
    font-size: 1.6rem;
  `,
  text_bold_18: `
    ${fonts.MarianneBold}
    font-size: 1.8rem;
  `,
  text_bold_20: `
    ${fonts.MarianneBold}
    font-size: 2rem;
  `,
  text_bold_22: `
  ${fonts.MarianneBold}
    font-size: 2.2rem;
  `,
  text_bold_24: `
    ${fonts.MarianneBold}
    font-size: 2.4rem;
  `,
  text_bold_32: `
    ${fonts.MarianneBold}
    font-size: 3.2rem;
  `,
  text_bold_36: `
    ${fonts.MarianneBold}
    font-size: 3.6rem;
  `,
  text_bold_50: `
  ${fonts.MarianneBold}
  font-size: 5rem;
  `,
  text_bold_60: `
    ${fonts.MarianneBold}
    font-size: 6rem;
  `,
  text_medium_32: `
    ${fonts.HelveticaNeueMedium}
    font-size: 3.2rem;
  `,
  text_medium_26: `
    ${fonts.HelveticaNeueMedium}
    font-size: 2.6rem;
  `,
  text_medium_18: `
    ${fonts.HelveticaNeueMedium}
    font-size: 1.8rem;
  `,
  text_medium_16: `
    ${fonts.HelveticaNeueMedium}
    font-size: 1.6rem;
  `,
  text_medium_14: `
    ${fonts.HelveticaNeueMedium}
    font-size: 1.4rem;
  `,
  text_medium_12: `
    ${fonts.HelveticaNeueMedium}
    font-size: 1.2rem;
  `,
}

export default textStyles
